import React from 'react'
import styled from 'styled-components';
import { useReactTable,
  flexRender, getCoreRowModel} from '@tanstack/react-table';

/**
 * Application Name
 */
export const APPLICATION = "oceanview";

/**
 * Local Testing
 */
export const DEVLOCAL = false;

/**
 * Mode
 */
export const MODE = "PROD";

/**
 *Data Year
 */
export const DataYear = new Date().getFullYear();

/**
 * Service URL
 */
export const SERVICE_URL = MODE === "PROD" ? "https://oceanic-edge-production.azurewebsites.net" : "https://oceanic-edge-test-f1-free.azurewebsites.net";
//export const SERVICE_URL = "https://localhost:44324";

/**
 * Table Styles
 */
export const Styles = styled.div`
padding: 1rem;

table {
  border-spacing: 0;
  border: 2px solid black;
  width:100%; 
  table-layout: auto;

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th {
    background-color: grey;
    position: sticky;
    top: 0;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;

    :last-child {
      border-right: 0;
    }
  }
}
`

/**
 * Table Styles
 */
export const PrintStyles = styled.div`
padding: 1rem;

table {
  border-spacing: 0;
  border: 2px solid black;
  width:100%

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th {
    background-color: grey;
    position: static;
    top: 0;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;

    :last-child {
      border-right: 0;
    }
  }
}
`

/**
 * Table Styles
 */
export const OdStyles = styled.div`
padding: 1rem;

table {
  border-spacing: 0;
  border: 2px solid black;
  max-width: 100%;
  max-height: 60vh;
  display: inline-block;
  overflow-x: auto;
  overflow-y: scroll;

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th {
    background-color: grey;
    position: sticky;
    top: 0;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;

    :last-child {
      border-right: 0;
    }
  }
}
`

export const ContentStyles = styled.div`
padding: 1rem;

table {
  border-spacing: 0;
  border: 2px solid black;
  max-height: 50vh;
  width: 100%;
  display: block;
  overflow-x: auto;
  overflow-y: scroll;
  white-space: nowrap;

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th {
    background-color: grey;
    position: sticky;
    top: 0;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;

    :last-child {
      border-right: 0;
    }
  }
}
`

/**
 * Table Styles
 */
 export const BillStyles = styled.div`
 padding: 1rem;
 
 table {
    width: 100%;
   tr {
    
   }
 
   th {
   }
 
   td {
   }
 }
 `

export const Table = ({ columns, data, hiddenFields }) => {
    // Use the state and functions returned from useTable to build your UI
    const table = useReactTable({
      columns,
      data,
      getCoreRowModel: getCoreRowModel(),
      initialState : {
          hiddenColumns: hiddenFields
      }
    })
  
    // Render the UI for your table
    return (
      <table role="table">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>
                  {flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row, i) => (
            <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
          ))}
        </tbody>
      </table>
    )
  }


  export const SelectableTable = ({ columns, data, hiddenFields, setSelection, rowSelection }) => {
    // Use the state and functions returned from useTable to build your UI
    const table = useReactTable({
        columns,
        data,
        getCoreRowModel: getCoreRowModel(),
        initialState : {
          hiddenColumns: hiddenFields
        },
        onRowSelectionChange: setSelection,
        state: {
          rowSelection
        },
        enableRowSelection: true,
        enableMultiRowSelection: true
      }
    )

    // Render the UI for your table
    return (
      <div>
        <button className='button' onClick={() => table.toggleAllRowsSelected(true)}>Select All</button>
        <button className='button' onClick={() => table.toggleAllRowsSelected(false)}>Deselect All</button>
        <table role="table">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, i) => (
              <tr key={row.id} 
              // Trigger selection on row click
              onClick={row.getToggleSelectedHandler()}
              style={{ 
                cursor: 'pointer',
                backgroundColor: row.getIsSelected() ? 'darkgray' : 'transparent' 
              }}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  

 